import React, { useRef, useState } from 'react';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import { ColumnTogglerGroupItem } from './ColumnTogglerGroupItem';
import { ColumnTogglerColumnItem } from './ColumnTogglerColumnItem';
import { groupItems, isGroupItem } from '../utils';
import AccurityIconButton from '../../buttons/components/AccurityIconButton';
export var ColumnToggler = function (_a) {
    var columns = _a.columns, onClick = _a.onClick;
    var anchorEl = useRef(null);
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var groupedListItems = groupItems(columns);
    var renderListItems = function () {
        return groupedListItems.map(function (item, idx) {
            if (isGroupItem(item)) {
                return React.createElement(ColumnTogglerGroupItem, { group: item, onClick: onClick, key: idx });
            }
            else {
                return React.createElement(ColumnTogglerColumnItem, { column: item, onClick: function (changedColumn) { return onClick([changedColumn]); }, key: idx });
            }
        });
    };
    return (React.createElement("div", { className: "columnToggler" },
        React.createElement(AccurityIconButton, { iconName: "mui:ViewWeekOutlined", title: "Toggle columns", onClick: function () { return setIsOpen(true); }, ref: anchorEl }),
        React.createElement(Popover, { open: isOpen, onClose: function () { return setIsOpen(false); }, anchorEl: !!anchorEl ? anchorEl.current : null, anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'right',
            } },
            React.createElement(List, { className: "columnToggler__list" }, renderListItems()))));
};
export default ColumnToggler;
export var sortColumnsByDefaultOrder = function (columns) { return columns.slice(0).sort(function (a, b) { return (a.defaultOrder - b.defaultOrder); }); };
//# sourceMappingURL=ColumnToggler.js.map